/**
 * 导购Agent - 提示词内容段接口
 *
 * 对齐后端《导购商品管理》文档接口 6 / 7：
 * - 读接口直接返回全表扁平数组，一行 = 一个内容段，不按 module_key 合并
 * - 保存是全量覆盖：带 id 的按 id 更新（后端保留原 id，不删除重建），
 *   不带 id 的为新增，未提交的旧内容段会被删除，所以 save 必须带上全部要保留的段
 * - content 里的占位符以 {id} 形式内嵌，后端复用 RobotPromptItemService 的转换规则
 */
import { apiGet, apiPost } from '@/utils/request';
import type { GuidePromptSection, GuidePromptSectionSavePayload } from '@/types/guideAgent';

export const guidePromptApi = {
  /** versionType 必传：接口自身默认是草稿(1)，这里给默认值反而会静默按线上(0)读，故不给 */
  list: (robotId: number, versionType: number) =>
    apiGet<GuidePromptSection[]>('/products/prompt-modules', {
      robot_id: robotId,
      version_type: versionType,
    }),
  /** 全量覆盖保存（线上版本只读，页面只在草稿态放开提交） */
  save: (robotId: number, versionType: number, items: GuidePromptSectionSavePayload[]) =>
    apiPost<GuidePromptSection[]>('/products/prompt-modules/save', {
      robot_id: robotId,
      version_type: versionType,
      items,
    }),
};
